define([
	"jquery",
	"underscore",
	"marionette",
	"behaviors/form_errors_behavior",
	"templates/payout/internal_transfer_item.html",
    "forms/payout/internal_transfer_form",
	"behaviors/datatables_behavior",
	"backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior, InternalTransferTemplate, InternalTransferForm, DatatablesBehavior) {
	return Marionette.View.extend({
		el: '#content_layout',

		behaviors: {
			formErrors: {
				behaviorClass: FormErrorsBehavior
			},
			datatables: {
				behaviorClass: DatatablesBehavior
			}
		},

		ui: {
			'submit':'#submit_btn',
			'add':'#add_transfer',
			'form': '#transfer_form',
			'table':'#transfer_table',
			'remove':'.minus_sign'
		},

		events:{
			'click @ui.submit' : 'submit',
			'click @ui.add' : 'addRow',
			'click @ui.remove' : 'removeRow'
		},

		initialize: function(){
			this.bindUIElements();

			// We init the datatable
			this.triggerMethod('init:table', {
				url: '/rest_payout/internal_transfer_history',
				order: [[ 0, "desc" ]],
				columns: [
					{
						'name':'reg_datetime',
						'data':'reg_datetime',
						'type': 'date'
					},
					{
						'name':'amount',
						'data':'amount'
					},
					{
						'name':'type',
						'data':'type_trans'

					},
					{
						'name':'mt4',
						'data':'target_mt4'
					},
					{
						'name':'status',
						'data':'status_trans'
					}
				]
			});

			this.idx = parseInt(window.rows) - 1;

			this.transferableClients = window.transferable_clients;
			this.tradeAccountNo = window.trade_account_no;
			this.mode = window.mode;
		},


		addRow: function(e){
			if(e) e.preventDefault();

			this.idx++;

			this.ui.table.append(InternalTransferTemplate({
				idx: this.idx,
				transferableClients: this.transferableClients,
				mode: this.mode,
                tradeAccountNo: this.tradeAccountNo
            }))
		},

		removeRow: function(e){
            if(e) e.preventDefault();

            var idx = $(e.currentTarget).attr('data-idx');
            this.$('#row_' + idx).hide();
            this.$('#row_' + idx).remove();
		},

		submit: function(e) {
            if (e) e.preventDefault();

            this.triggerMethod('hide:errors');

            // Since we want to validate each row, we'll have to loop on all of them and build the errors array
            var errors = {};
            var form = new InternalTransferForm();
            var formData = Backbone.Syphon.serialize(this.ui.form);

            // For each "from_mt4"
            _.each(formData.from_mt4, function (value, index, array) {
                // Set the form with the correct values, based on the index
                form.set({
                    from_mt4: value,
                    to_mt4: formData.to_mt4[index],
                    amount: formData.amount[index]
                });

                // Validate the row form
                var rowErrors = form.validate();
                // Errors!
                if (_.size(rowErrors) > 0) {
                    // Loop on them and add them to the errors array with the correct index
                    _.each(rowErrors, function (v, i, a) {
                        errors[i + "_" + index] = v;
                    });
                }
            });

            if (_.size(errors) < 1) {
                this.ui.form.submit();
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
	});
});
